<template>
  <div class="flex flex-wrap -mx-2">
    <div
      v-for="(eachFiles, index) in all_files"
      :key="index"
      class="sm:w-1/2 md:w-1/3 lg:w-1/4 px-2"
    >
      <vs-card class="file-card">
        <div slot="header">
            <img
            class="w-full file-image"
            :src="renderIcon(eachFiles)"
            alt=""
            />
        </div>
        <h5 class="file-name">{{ eachFiles.file_name }}</h5>
        <p>{{ eachFiles.size }}</p>

        <vs-button
            color="success"
            class="float-right"
            type="flat"
            @click="downloadImage(eachFiles)"
            icon-pack="feather"
            icon="icon-download"
        ></vs-button>
      </vs-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { getFileTypeIcon } from './FiletypeImage'

export default {
  name: 'uploadedFiles',
  props: ['all_files'],
  methods: {
    renderIcon (file_object) {
      return getFileTypeIcon(file_object)
    },
    downloadImage (item) {
      console.log(item)
      axios({
        url: `${item.file_path}`,
        method: 'GET',
        responseType: 'blob'
      })
        .then((response) => {
          const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileUrl

          fileLink.setAttribute('download', item.file_name)
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          console.log('hi')
        })
    }
  }
}
</script>